(function () {
  const slideSelector =
    '.flickity-slider .product-grid-item[data-slide]';

  function syncSlide(slide) {
    if (!slide || !slide.matches(slideSelector)) return;

    if (slide.getAttribute('aria-hidden') === 'true') {
      slide.setAttribute('inert', '');
    } else {
      slide.removeAttribute('inert');
    }
  }

  function syncAllSlides() {
    document.querySelectorAll(slideSelector).forEach(syncSlide);
  }

  function initAccessibilityHiddenSlides() {
    // Initial pass
    syncAllSlides();

    // Watch Flickity as it initializes and changes slide state
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        // aria-hidden changed on an existing product slide
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'aria-hidden'
        ) {
          syncSlide(mutation.target);
        }

        // Flickity or Shopify added/re-rendered slides
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function (node) {
            if (!(node instanceof Element)) return;

            if (node.matches(slideSelector)) {
              syncSlide(node);
            }

            node.querySelectorAll?.(slideSelector).forEach(syncSlide);
          });
        }
      });
    });

    observer.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['aria-hidden']
    });

    // Extra pass after other deferred theme initialization
    window.addEventListener('load', syncAllSlides);

    // Small delayed passes for late Flickity initialization
    setTimeout(syncAllSlides, 500);
    setTimeout(syncAllSlides, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initAccessibilityHiddenSlides
    );
  } else {
    initAccessibilityHiddenSlides();
  }
})();